import {IListOption as IOptions} from '../../../interfaces/globals';
import IDropDownOption from '../../../interfaces/ui/dropdown-option.interface';

export const getDropDownOptions = (options: IOptions[]): IDropDownOption[] => {
  return options.map(item => {
    return {
      label: item.title,
      value: item.value,
    } as IDropDownOption;
  });
};
